import React from "react";
import { PlayerCard } from "../../card";
import _ from "lodash";
import { connect } from "react-redux";
import { getGameName } from "../../shared/utils";
import * as gameAction from "../../../redux/game/action";
import cx from "classnames";

class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allUsersClues: []
    };
  }
  delPlayer = (data) => {
    this.props.deletePlayer(data);
  };

  static comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };

  componentDidUpdate() {
    let roomData = this.props.gameReducer;
    let roomObj = this.props.gameReducer.roomObj;

    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.game_state.clues &&
      roomObj.game_state.clues.length > 0
    ) {
      if (roomObj.game_state.clues.length > roomData.userClues.length) {
        const callAudioEl = document.getElementById("callAudio");
        let result = roomObj.game_state.clues.filter(
          SideBar.comparer(roomData.userClues)
        );
        if (result && result.length > 0) {
          let sound = roomObj.users.filter(
            (user) => user.player_id === result[0].player_id
          );
          this.props.setUserClues(roomObj.game_state.clues);
          this.setState(
            {
              // allUsersClues: roomObj.game_state.clues,
              audioUrl:
                result && result[0].player_id && sound[0].audio_effect
                  ? sound[0].audio_effect
                  : ""
            },
            () => {
              if (callAudioEl) {
                callAudioEl
                  .play()
                  .then(() => {})
                  .catch(() => {});
                setTimeout(() => {
                  callAudioEl.pause();
                  callAudioEl.currentTime = 0;
                }, 3000);
              }
            }
          );
        }
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.game_state.clues &&
      roomObj.game_state.clues.length < roomData.userClues.length
    ) {
      this.props.setUserClues(roomObj.game_state.clues);
      // return {
      //   allUsersClues: roomObj.users,
      // };
    }
  }

  render() {
    let roomData = this.props.gameReducer.roomObj;
    let getActiveUsers = roomData.users;
    // if(roomData.users && roomData.users.length >0){
    //   getActiveUsers = roomData.users.filter((user) => user.active === true);
    // }
    const uniqUsers = _.uniqBy(getActiveUsers, "user_id");

    let clues = [];
    let playerHands = [];
    let playedCards = [];
    if (roomData?.game_state?.clues) {
      clues = roomData.game_state.clues;
    }
    if (roomData?.game_state?.player_hands) {
      playerHands = roomData.game_state.player_hands;
    }
    if (roomData?.game_state?.played_cards) {
      playedCards = roomData.game_state.played_cards;
    }

    const gameName = getGameName(roomData);
    return (
      <div
        id="sidebar"
        className={cx("", {
          sidebarTw: this.props.gameReducer.roomObj.game_code === "TW"
        })}
      >
        <audio id="callAudio" src={this.state.audioUrl}></audio>
        <div className="scrollView">
          {uniqUsers && uniqUsers.length > 0 ? (
            uniqUsers.map((data, index) => {
              let score = 0;
              let clue_PlayCard = false;
              if (gameName !== "GAH") {
                let indexOfClue = clues.findIndex(
                  (clue) => clue.player_id === data.player_id
                );
                if (indexOfClue !== -1) {
                  clue_PlayCard = true;
                }
              } else {
                let indexOfUser = playerHands.findIndex(
                  (user) => user.player_id === data.player_id
                );
                let cardPlayed = playedCards.findIndex(
                  (user) => user.player_id === data.player_id
                );
                if (cardPlayed !== -1) {
                  clue_PlayCard = true;
                }

                if (indexOfUser !== -1) {
                  score = playerHands[indexOfUser].score;
                }
              }

              return (
                <PlayerCard
                  clue_PlayCard={clue_PlayCard}
                  score={score}
                  {...data}
                  key={index}
                  roomData={roomData}
                  delPlayer={this.delPlayer}
                />
              );
            })
          ) : (
            <div>No users found</div>
          )}
        </div>
      </div>
    );
  }
}

// export default SideBar;
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails
});

const mapDispatchToProps = (dispatch) => {
  return {
    setUserClues: (data) => dispatch(gameAction.setUserClues(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
